import { defineMessages } from 'react-intl'

export default defineMessages({
  title: {
    id: 'OrganizationClientConfigsPage.Title',
    defaultMessage: 'Client Configs'
  },
  addClientConfig: {
    id: 'OrganizationClientConfigsPage.AddClientConfig',
    defaultMessage: 'Add Client Config'
  },
  noClientConfigsTitle: {
    id: 'OrganizationClientConfigsPage.NoClientConfigsTitle',
    defaultMessage: 'No Client Configs'
  },
  noClientConfigsDescription: {
    id: 'OrganizationClientConfigsPage.NoClientConfigsDescription',
    defaultMessage: 'Get started by creating a new client config.'
  },
  targetingSectionLabel: {
    id: 'OrganizationClientConfigsPage.TargetingSectionLabel',
    defaultMessage: 'Targeting'
  },
  targetingSectionDescription: {
    id: 'OrganizationClientConfigsPage.TargetingSectionDescription',
    defaultMessage: 'Who should receive the following settings.'
  },
  configurationSectionLabel: {
    id: 'OrganizationClientConfigsPage.ConfigurationSectionLabel',
    defaultMessage: 'Configuration'
  },
  configurationSectionDescription: {
    id: 'OrganizationClientConfigsPage.ConfigurationSectionDescription',
    defaultMessage: 'What settings the targeted users will receive.'
  },
  notApplicable: {
    id: 'OrganizationClientConfigsPage.NotApplicable',
    defaultMessage: 'Not applicable to "{key}" client configuration'
  },
  keyLabel: {
    id: 'OrganizationClientConfigsPage.KeyLabel',
    defaultMessage: 'Key'
  },
  keyDescription: {
    id: 'OrganizationClientConfigsPage.KeyDescription',
    defaultMessage: 'A url-safe unique identifier'
  },
  defaultLabel: {
    id: 'OrganizationClientConfigsPage.DefaultLabel',
    defaultMessage: 'Default'
  },
  defaultDescription: {
    id: 'OrganizationClientConfigsPage.DefaultDescription',
    defaultMessage: 'Use this client config when no key is provided'
  },
  audienceLabel: {
    id: 'OrganizationClientConfigsPage.AudienceLabel',
    defaultMessage: 'Audience'
  },
  audienceDescription: {
    id: 'OrganizationClientConfigsPage.AudienceDescription',
    defaultMessage: 'Match against the specified groups and users'
  },
  widgetLabel: {
    id: 'OrganizationClientConfigsPage.WidgetLabel',
    defaultMessage: 'Widget'
  },
  widgetDescription: {
    id: 'OrganizationClientConfigsPage.WidgetDescription',
    defaultMessage: '​'
  },
  spaceIdLabel: {
    id: 'OrganizationClientConfigsPage.SpaceIdLabel',
    defaultMessage: 'Initial Space'
  },
  spaceIdDescription: {
    id: 'OrganizationClientConfigsPage.SpaceIdDescription',
    defaultMessage: 'The space used at the start of a new session'
  },
  labelLabel: {
    id: 'OrganizationClientConfigsPage.LabelLabel',
    defaultMessage: 'Label'
  },
  labelDescription: {
    id: 'OrganizationClientConfigsPage.LabelDescription',
    defaultMessage: 'The name that represents your digital assistant'
  },
  iconUrlLabel: {
    id: 'OrganizationClientConfigsPage.IconUrlLabel',
    defaultMessage: 'Icon URL'
  },
  iconUrlDescription: {
    id: 'OrganizationClientConfigsPage.IconUrlDescription',
    defaultMessage: 'An icon that represents your digital assistant'
  },
  supportUrlLabel: {
    id: 'OrganizationClientConfigsPage.SupportUrlLabel',
    defaultMessage: 'Support URL'
  },
  supportUrlDescription: {
    id: 'OrganizationClientConfigsPage.SupportUrlDescription',
    defaultMessage: 'e.g. https://example.com/help or mailto:help@example.com'
  },
  positionLabel: {
    id: 'OrganizationClientConfigsPage.PositionLabel',
    defaultMessage: 'Position'
  },
  positionDescription: {
    id: 'OrganizationClientConfigsPage.PositionDescription',
    defaultMessage: 'The position of the widget (e.g. `bottom-right`, `left max-[40rem]:bottom`)'
  },
  themeLabel: {
    id: 'OrganizationClientConfigsPage.ThemeLabel',
    defaultMessage: 'Theme'
  },
  themeDescription: {
    id: 'OrganizationClientConfigsPage.ThemeDescription',
    defaultMessage: 'The primary color (e.g. `#663399` or `rgb(102,51,153)`)'
  },
  promptLabel: {
    id: 'OrganizationClientConfigsPage.PromptLabel',
    defaultMessage: 'Initial Prompt'
  },
  promptDescription: {
    id: 'OrganizationClientConfigsPage.PromptDescription',
    defaultMessage: 'The message sent at the start of a new session (e.g. "Main Menu")'
  },
  advancedSectionLabel: {
    id: 'OrganizationClientConfigsPage.AdvancedSectionLabel',
    defaultMessage: 'Advanced'
  },
  advancedSectionDescription: {
    id: 'OrganizationClientConfigsPage.AdvancedSectionDescription',
    defaultMessage: 'Curiosity beckons, proceed with caution'
  },
  featuresLabel: {
    id: 'OrganizationClientConfigsPage.FeaturesLabel',
    defaultMessage: 'Features'
  },
  featuresDescription: {
    id: 'OrganizationClientConfigsPage.FeaturesDescription',
    defaultMessage: 'Please contact support for assistance'
  },
  rulesLabel: {
    id: 'OrganizationClientConfigsPage.RulesLabel',
    defaultMessage: 'Rules'
  },
  rulesDescription: {
    id: 'OrganizationClientConfigsPage.RulesDescription',
    defaultMessage: 'Extend config with audience targeted overrides'
  },
  nameLabel: {
    id: 'OrganizationClientConfigsPage.NameLabel',
    defaultMessage: 'Name'
  },
  nameDescription: {
    id: 'OrganizationClientConfigsPage.NameDescription',
    defaultMessage: 'A quick way to identify this rule'
  },
  updatedAt: {
    id: 'OrganizationClientConfigsPage.UpdatedAt',
    defaultMessage: 'Updated at'
  },
  updatedBy: {
    id: 'OrganizationClientConfigsPage.UpdatedBy',
    defaultMessage: 'Updated by'
  },
  actions: {
    id: 'OrganizationClientConfigsPage.Actions',
    defaultMessage: 'Actions'
  },
  updateClientConfigAction: {
    id: 'OrganizationClientConfigsPage.UpdateClientConfigAction',
    defaultMessage: 'Edit {key}'
  },
  deleteClientConfigAction: {
    id: 'OrganizationClientConfigsPage.DeleteClientConfigAction',
    defaultMessage: 'Delete {key}'
  },
  createClientConfig: {
    id: 'OrganizationClientConfigsPage.CreateClientConfig',
    defaultMessage: 'Add Client Config'
  },
  updateClientConfig: {
    id: 'OrganizationClientConfigsPage.UpdateClientConfig',
    defaultMessage: 'Edit Client Config'
  },
  deleteClientConfig: {
    id: 'OrganizationClientConfigsPage.DeleteClientConfig',
    defaultMessage: 'Delete Client Config'
  },
  editRule: {
    id: 'OrganizationClientConfigsPage.EditRuleConfig',
    defaultMessage: 'Edit Rule'
  },
  cancel: {
    id: 'OrganizationClientConfigsPage.Cancel',
    defaultMessage: 'Cancel'
  },
  create: {
    id: 'OrganizationClientConfigsPage.Create',
    defaultMessage: 'Create'
  },
  update: {
    id: 'OrganizationClientConfigsPage.Update',
    defaultMessage: 'Update'
  },
  delete: {
    id: 'OrganizationClientConfigsPage.Delete',
    defaultMessage: 'Delete'
  },
  deleteConfirmation: {
    id: 'OrganizationClientConfigsPage.DeleteConfirmation',
    defaultMessage: 'Are you sure you want to permenantly delete {key}?'
  }
})
